<template>
  <div class="p-grid irinox-form after-sales spare-parts">
    <div class="p-col-12 after-sales-model-details-body p-py-1">
      <p style="margin-top: 0rem; margin-bottom: 0;"><img src="/assets/irinox/icons/arrow_back.svg" alt="Back"
          @click="$functions.historyBack()" /> {{ $t('spareParts.title') }}</p>
      <span class="spare-parts-subtitle">{{ selectedLabel }}</span>
    </div>

    <!-- Topbar + Toolbar zoom -->
    <div class="p-grid p-nogutter p-my-1 p-jc-between p-ai-center"  style="width: 100%; min-height: 60px;">

      <div class="p-col-fixed spare-parts-topbar">
        <Carousel  v-if="fullScreen || $functions.isMobile()" :value="sparePartsDocs?.pages" :numVisible="5" :numScroll="1" :circular="true"
         :responsiveOptions="responsiveOptions" :showIndicators="false">
          <template #item="slotProps">
              <div class="spare-parts-drawing-buttons" @click="goTo(sparePartsDocs.spDocsId, slotProps.index+1)" :class="{active: (page ?? 1) - 1 === slotProps.index }">
                  {{ $t('spareParts.drawing') + ' ' + (slotProps.index+1) }}
              </div>
          </template>
        </Carousel>
      </div>

      <div class="p-col-fixed spare-parts-toolbar p-py-1" style="width: 300px;">
        <div class="p-d-flex p-ai-center p-jc-center" style="gap: 5px;">
          <i class="pi pi-minus-circle" @click="zoomOut" />
          <span class="z-value">{{ Math.round(scale * 100) }}%</span>
          <i class="pi pi-plus-circle" @click="zoomIn" />
        </div>
        <i class="pi pi-expand" @click="fitToScreen" style="font-weight: bold;"/>
        <!-- <button class="z-btn" @click="resetView">100%</button> -->
        <i :class="[fullScreen ? 'icon-drawing_zoom_out' : 'icon-drawing_zoom_in']" v-if="!$functions.isMobile()" @click="fullScreen = !fullScreen"/>
        <FavoriteWidget :docTreeId="docTreeId" mode="icon" />
        <i class="icon-print" @click="dialog.print=true" />
      </div>

    </div>

    <!-- Viewport + sidebar -->
    <div class="p-grid p-nogutter p-mx-3 p-my-1" style="width: 100%;">
      <div class="p-col">
        <div class="viewport" ref="viewport" @wheel.prevent="onWheel" @dblclick="onDblClick" @pointerdown="onPointerDown"
          @pointermove="onPointerMove" @pointerup="onPointerUp" @pointercancel="onPointerUp" @pointerleave="onPointerUp">
          <!-- Canvas (si scala e si trascina) -->
          <div class="canvas" :style="canvasStyle" ref="canvas">
            <!-- <img class="exploded-img" :src="'/after-sales/esploso/' + page + '.jpg'" alt="Exploded view" ref="img" @load="onImageLoad" draggable="false" /> -->
            <img class="exploded-img" :src="sparePartsDocs?.pages[page-1].table" alt="Exploded view" ref="img" @load="onImageLoad" draggable="false" width="1920" />

            <!-- Pin -->
            <button 
              v-for="(m,i) in markers" 
              :key="m.key || (m.id + '_' + i)" 
              class="pin" 
              :style="pinStyle(m)" 
              @pointerdown.stop
              @pointerenter="(e) => onPinEnter(e, m)" 
              @pointerleave="onPinLeave" 
              @click.stop="(e) => openPopup(e, m)"
              :aria-label="m.id">
              {{ m.id }}
            </button>
          </div>

        </div>
      </div>
      <div v-if="!fullScreen && !$functions.isMobile()" class="p-col-fixed" style="width: 300px;">
        <ScrollPanel class="spare-parts-drawing-vertical-panel">
          <div v-for="(doc, index) in sparePartsDocs?.pages" :key="index" class="spare-parts-drawing-thumbnail-vertical" :class="{active: (page ?? 1) - 1 === index }" @click="goTo(sparePartsDocs.spDocsId, index+1)">
            {{ $t('spareParts.drawing') + ' ' + (index+1) }}
            <img :src="doc.thumbnail" :alt="'DRAWINGS'" />
          </div>
        </ScrollPanel>
      </div>

    </div>

  </div>

  <!-- Overlay con dettagli (gestisce anche più parti per posizione) -->
  <OverlayPanel ref="op" appendTo="body" @mouseenter="onOverlayEnter" @mouseleave="onOverlayLeave" 
    class="spare-parts-overlay" :style="{ '--op-offset-y': overlayOffsetY + 'px' }">
    <div v-if="selectedMarker" class="p-2 min-w-72">
      <div class="p-text-center">
        {{ $t('spareParts.position') }}
        <Tag :value="selectedMarker.id" />
      </div>

      <template v-if="partsFor(selectedMarker).length">
        <div class="text-sm grid gap-3">
          <DataTable :value="partsFor(selectedMarker)" stripedRows responsiveLayout="stack" breakpoint="960px"
            :autoLayout="true" class="p-mt-2" selectionMode="single" @row-click="partClick" sortMode="multiple"
            :multiSortMeta="[{ field: 'code', order: 1 }, { field: 'description', order: 1 }, { field: 'note', order: 1 }]">

            <Column field="code" :header="$t('spareParts.col_code')"></Column>
            <Column field="description" :header="$t('spareParts.col_description')"></Column>
            <Column field="note" :header="$t('spareParts.col_note')"></Column>
            <Column field="price" :header="$t('spareParts.col_price')">
              <template #body="slotProps">
                {{ slotProps.data.price ? $n(slotProps.data.price, 'money') : '-' }}
                {{ slotProps.data.price ? (slotProps.data.currency === 'EUR' ? '€ ' : '$ ') : '' }}
              </template>
            </Column>
            <Column></Column>

            <!-- <Column field="startTimestamp" :header="$t('energy.details.col_date')" sortable >
              <template #body="slotProps">
                {{ $d( $functions.utcDate(slotProps.data.startTimestamp,msConverter) , is24hour ? 'cycle' : 'cycle12' ) }}
              </template>
</Column> -->

          </DataTable>
          <!-- <div
            v-for="(item, i) in partsFor(selectedMarker)"
            :key="rowKey(item, i)"
            class="rounded-md border p-2"
          > -->


          <!-- <div class="font-medium">
              {{ item.description || item.DESCRIZIONE || 'Ricambio' }}
            </div>
            <div class="mt-1">
              <b>Codice:</b> {{ item.code || item.CODICE }}
            </div>
            <div v-if="item.qty != null || item.QTA != null">
              <b>Q.tà:</b> {{ item.qty ?? item.QTA }}
            </div>
            <div v-if="item.note || item.NOTA">
              <b>Note:</b> {{ item.note ?? item.NOTA }}
            </div> -->
          <!-- </div> -->
        </div>
      </template>

      <template v-else>
        <div class="text-sm text-gray-500">
          Nessun ricambio associato a {{ selectedMarker.id }}.
        </div>
      </template>
    </div>
  </OverlayPanel>

  <Print :spDocsId="spDocsId" :visible="dialog.print" :page="page"
    @update:visible="dialog.print = $event" />

  <SparePartsPreorder :visible="dialog.preorder" :sparePart="selectedSparePart"
    @update:visible="dialog.preorder = $event" />

  <IrinoxDialogDark :visible="dialog.error" mode="error" :message="$t('details.dialog_error')" :life="3000"
    @update:visible="dialog.error = $event" />
</template>

<script>
import AfterSalesService from '../../../service/AfterSalesService'
import IrinoxDialogDark from '../../IrinoxDialogDark.vue'
import { mapGetters } from 'vuex'
import SparePartsPreorder from './SparePartsPreorder.vue'
import FavoriteWidget from '../FavoriteWidget.vue'
import Print from './Print.vue'

export default {
  components: { IrinoxDialogDark, SparePartsPreorder,  FavoriteWidget, Print },
  data() {
    return {
      docTreeId: Number(this.$route.params.docTreeId),
      table: this.$route.params.table,

      markers: [],
      partsByPos: {},
      partsByMarker: {},
      selectedMarker: null,
      dialog: {
        error: false,
        preorder: false,
        print: false,
      },

      fullScreen: false,

      responsiveOptions: [
                {
                    breakpoint: '1400px',
                    numVisible: 4,
                    numScroll: 1,
                    page: (this.page-1)/4
                },
                {
                    breakpoint: '1199px',
                    numVisible: 3,
                    numScroll: 1,
                    page: (this.page-1)/3
                },
                {
                    breakpoint: '767px',
                    numVisible: 2,
                    numScroll: 1,
                    page: (this.page-1)/2
                },
                {
                    breakpoint: '575px',
                    numVisible: 1,
                    numScroll: 1,
                    page: (this.page-1)/1
                }
            ],

      // === Stato zoom/pan ===
      scale: 1,
      minScale: 0.2,
      maxScale: 4,
      zoomStep: 1.2,
      translateX: 0,
      translateY: 0,
      isPanning: false,
      panStart: { x: 0, y: 0 },
      translateStart: { x: 0, y: 0 },

      // per fit-to-screen
      naturalWidth: 0,
      naturalHeight: 0,

      // pinch (mobile)
      pointers: new Map(),
      pinchInit: null,

      hoverHideTimer: null,
      hoverDelay: 50,       // ms: piccola soglia anti-flicker --- 280
      openGuardUntil: 0,      // timestamp: durante questa finestra NON nascondere
      openGuardMs: 100,       // ~1/4s appena dopo l'apertura --- 250

      lastAnchorEl: null,

      selectedSparePart: null,
    }
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
      sparePartsDocs: 'afterSales/sparePartsDocs',
      docTreeRaw: 'afterSales/docTreeRaw',
      favorites: 'afterSales/favorites',
    }),
    canvasStyle() {
      return {
        transform: `translate(${this.translateX}px, ${this.translateY}px) scale(${this.scale})`,
        transformOrigin: '0 0'
      }
    },
    spDocsId() {
      const parts = this.$functions.decrypt('table', this.table).split('|||')
      return parts.length === 2 ? Number(parts[0]) : null
    },
    page() {
      const parts = this.$functions.decrypt('table', this.table).split('|||')
      return parts.length === 2 ? Number(parts[1]) : null
    },
    selectedModel() {
      return this.docTreeRaw.find(item => item.docTreeId == this.docTreeId);
    },
    selectedLabel() {
      if(this.selectedModel) {
        for(let i=5; i>=1; i--) {
          if(this.selectedModel['level'+i]) {
            return this.selectedModel['level'+i+'Translation'] || this.selectedModel['level'+i];
          }
        }
      }
      return 'UNKNOWN';
    },
    overlayOffsetY() {
      const val = this.scale < 0.8 ? (this.scale - 0.8) * 100 : 0;
      return Math.max(val, -60); // limite max in negativo
    }
  },
  created() {
    this.afterSalesService = new AfterSalesService()
  },
  mounted() {

    if (!this.sparePartsDocs || !this.sparePartsDocs.pages || this.sparePartsDocs.pages.length === 0
      || this.sparePartsDocs.spDocsId !== this.spDocsId || this.page > this.sparePartsDocs.pages.length || this.page < 1) {
      // errore, torno indietro
      this.$router.push({ name: 'after-sales-tree', params: { docTreeId: this.docTreeId } });
      return;
    }

    this.loadComponents();

    // abilita gesture
    if (this.$refs.viewport) {
      this.$refs.viewport.style.touchAction = 'none'
    }
  },
  beforeUnmount() {
    // pulisci timer
    if (this.hoverHideTimer) {
      clearTimeout(this.hoverHideTimer)
      this.hoverHideTimer = null
    }
  },
  methods: {
    loadComponents() {
      this.afterSalesService.getSparePartsComponents(this.personaltoken, this.spDocsId, this.page)
        .then((data) => {
          if (data.code == "200") {

            // Build partsByPos, partsByMarker e markers (più marker per stessa POS)
            const partsByPos = {};
            const partsByMarker = {};     // 👈 NEW
            const markers = [];
            const seenCoord = new Set();  // evita duplicati esatti di marker

            for (const it of data.body) {
              const pos = String(it.position || '').trim();
              if (!pos) continue;

              // normalizza record pezzo
              const rec = {
                position: pos,
                code: it.code ?? '',
                description: it.description ?? '',
                note: it.note ?? null,
                quantity: it.quantity ?? it.qty ?? null,
                price: it.price ?? 0,
                currency: it.currency ?? 'EUR',
                recommended: !!it.recommended
              };

              // ---- elenco "generale" per POS (fallback / ricerche) ----
              if (!partsByPos[pos]) partsByPos[pos] = [];
              partsByPos[pos].push(rec);

              // ---- marker specifico per (pos, x, y) ----
              const hasCoords = it.x != null && it.y != null;
              if (hasCoords) {
                const x = Number(it.x);
                const y = Number(it.y);
                const mk = `${pos}@${x.toFixed(4)},${y.toFixed(4)}`;  // chiave stabile

                // tabella pezzi per marker
                if (!partsByMarker[mk]) partsByMarker[mk] = [];
                partsByMarker[mk].push(rec);

                // marker visuale (uno per coppia pos,x,y)
                if (!seenCoord.has(mk)) {
                  seenCoord.add(mk);
                  markers.push({ id: pos, x, y, key: mk });
                }
              }
            }

            this.partsByPos = partsByPos;
            this.partsByMarker = partsByMarker;   // 👈 NEW
            this.markers = markers;

          } else {
            console.error(JSON.stringify(data));
            this.partsByPos = {}
            this.markers = []
            this.dialog.error = true;
          }
        })
        .catch(error => {
          console.error("ERROR " + error);
          this.partsByPos = {}
          this.markers = []
          this.dialog.error = true;
        });
    },
    // ===== Pins & overlay =====
    pinStyle(m) {
      return { left: m.x + '%', top: m.y + '%' }
    },
    openPopup(event, marker) {
      if (event.pointerType === 'mouse') return;
      
      const anchor = event.currentTarget;
      const sameAnchor = this.lastAnchorEl === anchor;
      this.selectedMarker = marker;

      const now = performance.now();
      const show = () => {
        this.lastAnchorEl = anchor;
        this.$refs.op.show(event);
        this.openGuardUntil = now + this.openGuardMs;
      };

      if (this.$refs.op?.visible) {
        if (sameAnchor) {
          if (typeof this.$refs.op.align === 'function') {
            this.$refs.op.align();
          } else {
            this.$refs.op.hide();
            this.$nextTick(show);
          }
        } else {
          this.$refs.op.hide();
          this.$nextTick(show);
        }
      } else {
        show();
      }
    },

    partsFor(marker) {
      if (!marker) return [];
      // chiave per marker specifico (POS@x,y)
      const mk = (marker.key)
        ? marker.key
        : `${marker.id}@${Number(marker.x).toFixed(4)},${Number(marker.y).toFixed(4)}`;

      return this.partsByMarker?.[mk]
          ?? this.partsByPos?.[marker.id]
          ?? [];
    },
    rowKey(item, idx) {
      return [item.code || item.codice || '', item.note || '', idx].join('_')
    },

    // ===== Image sizing =====
    onImageLoad(e) {
      const img = e.target
      this.naturalWidth = img.naturalWidth
      this.naturalHeight = img.naturalHeight
      this.fitToScreen()
    },

    // ===== Toolbar =====
    zoomIn() {
      this.zoomAtViewportCenter(this.zoomStep)
    },
    zoomOut() {
      this.zoomAtViewportCenter(1 / this.zoomStep)
    },
    resetView() {
      this.scale = 1
      this.translateX = 0
      this.translateY = 0
    },
    fitToScreen() {
      const vp = this.$refs.viewport
      if (!vp || !this.naturalWidth || !this.naturalHeight) return
      const sx = vp.clientWidth / this.naturalWidth
      const sy = vp.clientHeight / this.naturalHeight
      const s = Math.max(Math.min(sx, sy), this.minScale)
      this.scale = Math.min(s, this.maxScale)

      // centra l'immagine nel viewport
      const imgW = this.naturalWidth * this.scale
      const imgH = this.naturalHeight * this.scale
      this.translateX = Math.max(0, (vp.clientWidth - imgW) / 2)
      this.translateY = Math.max(0, (vp.clientHeight - imgH) / 2)
    },

    // ===== Zoom al centro del viewport (fix: niente variabili inutilizzate) =====
    zoomAtViewportCenter(factor) {
      const vp = this.$refs.viewport
      if (!vp) return
      const rect = vp.getBoundingClientRect()
      const centerX = rect.left + vp.clientWidth / 2
      const centerY = rect.top + vp.clientHeight / 2
      this.zoomAtPoint(factor, centerX, centerY)
    },

    // ===== Wheel / DblClick =====
    onWheel(ev) {
      const factor = ev.deltaY > 0 ? 1 / 1.1 : 1.1
      this.zoomAtPoint(factor, ev.clientX, ev.clientY)
    },
    onDblClick(ev) {
      this.zoomAtPoint(this.zoomStep, ev.clientX, ev.clientY)
    },

    // ===== Zoom attorno a un punto del viewport =====
    zoomAtPoint(factor, clientX, clientY) {
      const newScale = this.clamp(this.scale * factor, this.minScale, this.maxScale)
      const realFactor = newScale / this.scale
      if (realFactor === 1) return

      const vp = this.$refs.viewport
      const rect = vp.getBoundingClientRect()

      // punto nel sistema canvas
      const px = (clientX - rect.left - this.translateX) / this.scale
      const py = (clientY - rect.top - this.translateY) / this.scale

      // nuova translate in modo che il punto rimanga “ancorato”
      this.translateX = clientX - rect.left - px * newScale
      this.translateY = clientY - rect.top - py * newScale
      this.scale = newScale

      // opzionale: chiudi l'overlay per evitare posizionamenti strani durante lo zoom
      this.$refs.op?.hide?.()

      this.clampPan()
    },

    // ===== Pan (drag/pinch) =====
    onPointerDown(ev) {
      // se hai cliccato un pin o l’overlay, non iniziare pan/pinch
      if (ev.target.closest?.('.pin') || ev.target.closest?.('.p-overlaypanel')) {
        return
      }
      this.$refs.viewport.setPointerCapture(ev.pointerId)
      this.pointers.set(ev.pointerId, { x: ev.clientX, y: ev.clientY })

      if (this.pointers.size === 1) {
        this.isPanning = true
        this.panStart = { x: ev.clientX, y: ev.clientY }
        this.translateStart = { x: this.translateX, y: this.translateY }
      } else if (this.pointers.size === 2) {
        this.isPanning = false
        this.pinchInit = this.getPinchState()
      }
    },
    onPointerMove(ev) {
      if (!this.pointers.has(ev.pointerId)) return
      this.pointers.set(ev.pointerId, { x: ev.clientX, y: ev.clientY })

      if (this.pointers.size === 1 && this.isPanning) {
        const dx = ev.clientX - this.panStart.x
        const dy = ev.clientY - this.panStart.y
        this.translateX = this.translateStart.x + dx
        this.translateY = this.translateStart.y + dy
        this.$refs.op?.hide?.()
        this.clampPan()
      } else if (this.pointers.size === 2) {
        const cur = this.getPinchState();
        const init = this.pinchInit
        if (!cur || !init) return

        // fattore di scala relativo
        const factor = cur.distance / init.distance
        const newScale = this.clamp(init.scale * factor, this.minScale, this.maxScale)

        const vp = this.$refs.viewport
        const rect = vp.getBoundingClientRect()
        const cx = cur.center.x - rect.left
        const cy = cur.center.y - rect.top

        const px = (cx - this.translateX) / this.scale
        const py = (cy - this.translateY) / this.scale

        this.translateX = cx - px * newScale
        this.translateY = cy - py * newScale
        this.scale = newScale

        // pan del centro pinch
        const dcx = cur.center.x - init.center.x
        const dcy = cur.center.y - init.center.y
        this.translateX += dcx
        this.translateY += dcy

        this.pinchInit = { ...cur, scale: this.scale }
        this.clampPan()
      }
    },
    onPointerUp(ev) {
      if (this.$refs.viewport.hasPointerCapture?.(ev.pointerId)) {
        this.$refs.viewport.releasePointerCapture(ev.pointerId)
      }
      this.pointers.delete(ev.pointerId)
      if (this.pointers.size === 0) {
        this.isPanning = false
        this.pinchInit = null
      } else if (this.pointers.size === 1) {
        const [rest] = this.pointers.values()
        this.isPanning = true
        this.panStart = { x: rest.x, y: rest.y }
        this.translateStart = { x: this.translateX, y: this.translateY }
      }
    },
    getPinchState() {
      const it = Array.from(this.pointers.values())
      const a = it[0],
        b = it[1]
      const dx = b.x - a.x
      const dy = b.y - a.y
      const center = { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }
      const distance = Math.hypot(dx, dy)
      return { center, distance, scale: this.scale }
    },

    // ===== Clamp pan (fix: niente maxX/maxY inutilizzati) =====
    clampPan() {
      const vp = this.$refs.viewport;
      if (!vp || !this.naturalWidth) return;

      const imgW = this.naturalWidth * this.scale;
      const imgH = this.naturalHeight * this.scale;

      // se più piccola del viewport, resta centrata
      if (imgW <= vp.clientWidth) this.translateX = Math.max(0, (vp.clientWidth - imgW) / 2);
      else {
        const minX = vp.clientWidth - imgW;      // negativo
        this.translateX = Math.min(Math.max(this.translateX, minX), 0);
      }

      if (imgH <= vp.clientHeight) this.translateY = Math.max(0, (vp.clientHeight - imgH) / 2);
      else {
        const minY = vp.clientHeight - imgH;     // negativo
        this.translateY = Math.min(Math.max(this.translateY, minY), 0);
      }
    },


    clamp(v, a, b) {
      return Math.max(a, Math.min(b, v))
    },

    onPinEnter(event, marker) {
      // niente hover su touch
      if (event.pointerType === 'touch' || event.pointerType === 'pen') return;

      if (this.hoverHideTimer) { clearTimeout(this.hoverHideTimer); this.hoverHideTimer = null; }

      const anchor = event.currentTarget;
      const sameAnchor = this.lastAnchorEl === anchor;
      this.selectedMarker = marker;

      const now = performance.now();
      const show = () => {
        this.lastAnchorEl = anchor;
        this.$refs.op.show(event);
        this.openGuardUntil = now + this.openGuardMs;
      };

      if (this.$refs.op?.visible) {
        if (sameAnchor) {
          if (typeof this.$refs.op.align === 'function') this.$refs.op.align();
          else { this.$refs.op.hide(); this.$nextTick(show); }
        } else {
          this.$refs.op.hide();
          this.$nextTick(show);
        }
      } else {
        show();
      }
    },
    onPinLeave(event) {
      if (event.pointerType === 'touch' || event.pointerType === 'pen') return; // niente hide su touch
      const now = performance.now();
      if (now < this.openGuardUntil) return;
      this.hoverHideTimer = setTimeout(() => {
        this.$refs.op?.hide?.();
        this.hoverHideTimer = null;
      }, this.hoverDelay);
    },


    onOverlayEnter() {
      if (this.hoverHideTimer) {
        clearTimeout(this.hoverHideTimer);
        this.hoverHideTimer = null;
      }
    },

    onOverlayLeave() {
      const now = performance.now();
      if (now < this.openGuardUntil) return;

      this.hoverHideTimer = setTimeout(() => {
        this.$refs.op?.hide?.();
        this.hoverHideTimer = null;
      }, this.hoverDelay);
    },

    partClick(event) {
      this.$refs.op?.hide?.()
      this.lastAnchorEl = null;
      setTimeout(function () {
        this.selectedSparePart = event.data;
        this.dialog.preorder = true;
      }.bind(this), 300);
    },

    goTo(spDocsId, page) {
      this.table = this.$functions.crypt("table", spDocsId+"|||"+page);
      this.loadComponents();
      // this.$router.push({ name: 'after-sales-spare-parts', params: { docTreeId: this.docTreeId, table: this.$functions.crypt("table", spDocsId+"|||"+page) } });
    },

  }
}
</script>

<style>

.spare-parts-overlay.p-overlaypanel {
  transform: translateY(var(--op-offset-y));
}

</style>
